import { Injectable } from '@angular/core';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';
import { Router } from '@angular/router';
import { GlobalService } from 'app/compartilhado/servicos/global.service';
import { OwsClientService } from 'ows-library';
import { Subject, Subscription } from 'rxjs';
import { AuthorizationServicesEnum, OwsServiceErrorResponse } from 'ows-library';
import { DadosPagamentoModel } from 'app/agendamento-vistorias/agendamento-go-form/models/DadosPagamento.model';
import { ProvedorCobrancaNome } from 'app/agendamento-vistorias/agendamento-go-form/models/ProvedorCobrancaNomeEnum';

@Injectable()
export class PagamentoService {

  creditoFormChanged = new Subject<any>();
  pagamentoCreditoChanged = new Subject<any>();
  dadosPagamento: DadosPagamentoModel;
  pesquisaFlag = false;
  exibePaginaPagamento = true;
  cartaoCreditoTokenId = '';
  provedorCobrancaChave = '';
  falhaPagamentoChanged = new Subject<any>();

  constructor(private owsClientService: OwsClientService,
              private popUpService: PopUpService,
              private globalService: GlobalService,
              private router: Router) {
  }

  efetuarPagamentoCreditoIugu(pagamentoTipo: string) {
    if (pagamentoTipo == 'C' && this.cartaoCreditoTokenId !== '') {
      this.dadosPagamento.CartaoCreditoTokenId = this.cartaoCreditoTokenId;
    }
    this.dadosPagamento.PagamentoTipo = pagamentoTipo;
    this.owsClientService.post<any>('agendamentosvistorias/pagamento', this.dadosPagamento, {
      authorizationService: AuthorizationServicesEnum.None
    }).subscribe(resposta => {
      this.pesquisaFlag = false;
      if (resposta.body && resposta.body.CheckoutUrl) {
        this.pagamentoCreditoChanged.next(resposta.body.CheckoutUrl);
      } else {
        this.pagamentoCreditoChanged.next(false);
      }
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }

        //2116: Campo CPF/CNPJ Inválido.
        if (error.error && error.error.Code == 2116) {
          this.falhaPagamentoChanged.next();
        }

        this.globalService.exibirLoadingPagamento(false);
        this.pesquisaFlag = false;

        if (pagamentoTipo == 'C') {
          this.exibePaginaPagamento = true;
          this.creditoFormChanged.next();
        }
      });
  }
}